<script setup lang="ts">
/* eslint-disable */
import {
  FolderCodeIcon,
  Upload01Icon,
  UploadCloud02Icon,
} from '@gohighlevel/ghl-icons/24/outline'
import { UITextSmRegular, UITextXsRegular } from '@gohighlevel/ghl-ui'
import { ref } from 'vue'

const emit = defineEmits(['uploadFromSystem', 'chooseFromMediaLibrary'])

const showUploadModal = ref(false)

const openUploadModal = () => {
  showUploadModal.value = !showUploadModal.value
}

const closeUploadModal = () => {
  showUploadModal.value = false
}

const uploadFromSystem = () => {
  // Create a file input element and trigger click
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/png, image/jpeg, image/jpg, image/gif'
  input.onchange = event => {
    const target = event.target as HTMLInputElement
    const file = target.files?.[0]
    if (file) {
      // Create a new event object with the file data
      const fileEvent = {
        target: {
          files: [file],
        },
        file: file,
      }
      emit('uploadFromSystem', fileEvent)
    }
  }
  input.click()
  closeUploadModal()
}

const chooseFromMediaLibrary = () => {
  emit('chooseFromMediaLibrary')
  closeUploadModal()
}
</script>

<template>
  <div>
    <div
      class="flex w-full cursor-pointer flex-col items-center gap-1 rounded-xl border-2 border-gray-200 p-4"
      @click="openUploadModal"
      @mouseleave="closeUploadModal"
      >
      <div class="calendars-upload-icon">
        <UploadCloud02Icon class="h-6 w-6 text-gray-600" />
      </div>
      <div class="relative">
        <UITextSmRegular>
          <span class="font-semibold text-blue-600">
            {{ $t('calendar_advanced.meeting_details.click_to_upload') }}
          </span>
          {{ $t('calendar_advanced.meeting_details.or_drag_and_drop') }}
        </UITextSmRegular>

        <!-- Upload Modal -->
        <div
          v-if="showUploadModal"
          class="absolute left-[40%] top-[90%] z-50 mt-1 -translate-x-1/2"
          @click="closeUploadModal"
          tabindex="0"
          role="button"
        >
          <div
            class="w-[250px] rounded-[6px] border-[1px] border-gray-300 bg-white p-1 shadow-sm"
            @click.stop
          >
            <div class="">
              <button
                @click="uploadFromSystem"
                class="flex w-full items-center gap-2 rounded-lg p-[5px] text-left transition-colors hover:bg-gray-50"
              >
                <div class="flex h-6 w-6 items-center justify-center">
                  <Upload01Icon class="h-5 w-5 text-gray-600" />
                </div>
                <span class="font-normal text-gray-700">{{
                  $t('calendar_advanced.meeting_details.upload_from_system')
                }}</span>
              </button>

              <button
                @click="chooseFromMediaLibrary"
                class="flex w-full items-center gap-2 rounded-lg p-[5px] text-left transition-colors hover:bg-gray-50"
              >
                <div class="flex h-6 w-6 items-center justify-center">
                  <FolderCodeIcon class="h-5 w-5 text-gray-600" />
                </div>
                <span class="font-normal text-gray-700">{{
                  $t(
                    'calendar_advanced.meeting_details.choose_from_media_storage'
                  )
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <UITextXsRegular>
        {{ $t('tooltips.image_upload_tooltip') }}
      </UITextXsRegular>
    </div>
  </div>
</template>

<style scoped>
.calendars-upload-icon {
  display: flex;
  margin: 0 auto 0.5rem;
  background: var(--gray-100);
  align-items: center;
  justify-content: center;
  border: 10px solid var(--gray-50);
  border-radius: 100%;
  width: 60px;
  height: 60px;
  box-sizing: border-box;
}
</style>
